import RentalLayout from "../../common/RentalLayout";
import Rental from "../../components/rental/Rental";

const RentalPage = () => {
    return (
        <RentalLayout>
            <Rental />
        </RentalLayout>
    );
};

export default RentalPage;